import React from 'react';
import { ScrollRestoration } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap5';

import routes from 'app/routes';

export default function Index() {
  return (
    <div className="content">
      <Row>
        <Col lg={{ span: 6, order: 'last' }}>
          <div className="bg-photo bg-managers-programs-success-photo" />
        </Col>

        <Col lg={{ span: 6, order: 'first' }}>
          <div className="py-4 px-sm-4 p-xxl-5">
            <h1 className="mb-5">Thank you!</h1>

            <p>
              Your members&apos; programs have been successfully assigned and are ready to go.
            </p>

            <p>
              Fantastic! You&apos;ve successfully assigned programs to your new members.
              For new members, please send an invitation to start their LeggUP program today.
              Existing members will receive a notification about their new program.
              We can&apos;t wait to see how our program helps them climb the ladder of professional success.
            </p>

            <a href={routes.managers.invite.index} className="btn btn-primary mt-4">
              Invite Members
            </a>
          </div>
        </Col>
      </Row>

      <ScrollRestoration />
    </div>
  );
}
